<template>
  <div class="modeList" @click="detail">
    <div class="modeList-title">
      <h3>{{ item.xm ? item.xm : "-" }}-{{ item.xh ? item.xh : "-" }}</h3>
      <div
        :class="{
          header_icon: true,
          man: item.xbmc === '男',
          woman: item.xbmc === '女'
        }"
      >
        <svg class="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
          <path
            d="M11.5,0.5 L11.5,5 L10.5,5 L10.5,2.102 L8.00732756,4.59710411 C8.62832483,5.36858865 9,6.34923565 9,7.41669203 C9,9.9019734 6.98528137,11.916692 4.5,11.916692 C2.01471863,11.916692 0,9.9019734 0,7.41669203 C0,4.93141065 2.01471863,2.91669203 4.5,2.91669203 C5.55697954,2.91669203 6.52884536,3.28110718 7.29681175,3.89115179 L9.688,1.5 L7,1.5 L7,0.5 L11.5,0.5 Z M4.5,3.91669203 C2.56700338,3.91669203 1,5.4836954 1,7.41669203 C1,9.34968865 2.56700338,10.916692 4.5,10.916692 C6.43299662,10.916692 8,9.34968865 8,7.41669203 C8,5.4836954 6.43299662,3.91669203 4.5,3.91669203 Z"
            fill="currentColor"
            fill-rule="nonzero"
          ></path>
        </svg>
        <span>{{ item.xbmc ? item.xbmc : "-" }}</span>
      </div>
    </div>
    <ul>
      <li class="modeList-item">
        <span>选课状态:</span>
        <p>{{ item.xkzt ? item.xkzt : "-" }}</p>
      </li>
      <li class="modeList-item">
        <span>选课方式:</span>
        <p>{{ item.xkfs ? item.xkfs : "-" }}</p>
      </li>
    </ul>
    <ul class="modeList-textarea">
      <li>
        <span>学生标签:</span>
        <p>{{ item.bqname ? item.bqname : "-" }}</p>
      </li>
      <li>
        <span>院系:</span>
        <p>{{ item.yxmc ? item.yxmc : "-" }}</p>
      </li>
      <li>
        <span>专业:</span>
        <p>{{ item.zymc ? item.zymc : "-" }}</p>
      </li>
      <li>
        <span>班级:</span>
        <p>{{ item.bjmc ? item.bjmc : "-" }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "modeList",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    detail() {
      this.$emit("detail", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.modeList {
  position: relative;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  .modeList-title {
    display: flex;
    align-items: center;
    margin-bottom: 13px;

    h3 {
      max-width: calc(~"100% - 42px");
      font-family: SourceHanSansCN-Medium;
      font-size: 16px;
      line-height: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bolder;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 17px;
      border-radius: 9px;
      margin-left: 4px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      letter-spacing: 0;
      font-weight: 400;
      .svg {
        width: 12px;
        height: 12px;
      }
      span {
        margin-left: 2px;
      }

      &.man {
        background: rgba(1, 137, 249, 0.15);
        color: #0189f9;
      }
      &.woman {
        background: rgba(255, 71, 60, 0.15);
        color: #ff473c;
      }
    }
  }
  .modeList-item {
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    span {
      white-space: nowrap;
    }
    p {
      white-space: wrap;
      margin-left: 5px;
    }
    & + .modeList-item {
      margin-top: 8px;
    }
  }
  .modeList-textarea {
    display: flex;
    flex-wrap: wrap;
    margin-top: 11px;
    background-image: linear-gradient(
      90deg,
      #f2f2f4 0%,
      rgba(242, 242, 244, 0) 100%
    );
    border-radius: 4px;
    padding: 6px;
    box-sizing: border-box;
    li {
      display: flex;
      box-sizing: border-box;
      width: calc(~"50% - 6px");
      font-family: SourceHanSansCN-Regular;
      line-height: 25px;
      padding: 0 6px;
      span {
        white-space: nowrap;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        font-weight: 400;
      }
      p {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        font-weight: 400;
        margin-left: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/xkmdck/mode/modeList1.vue